import React, { useState, useEffect } from "react";
import styles from "./RollingStatus.module.css";
import { TooltipHost, TooltipDelay } from "@fluentui/react";
import { tooltipHostStyles } from "../../styles_glob";

interface RollingStatusProps {
    newText: string;
    details?: string;
}

const RollingStatus: React.FC<RollingStatusProps> = ({ newText, details }) => {
    const [text, setText] = useState(newText);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (newText !== text) {
            setIsAnimating(true);
            const timeout = setTimeout(() => {
                setText(newText);
                setIsAnimating(false);
            }, 300); // Match CSS transition duration
            return () => clearTimeout(timeout);
        }
    }, [newText, text]);

    return (
        <TooltipHost content={(<div className={styles.toolTipText}>{details}</div>)} calloutProps={{ gapSpace: 0 }} className={details ? styles.toolTipWrapper : styles.toolTipHidden} delay={TooltipDelay.zero} styles={tooltipHostStyles}>
            <div className={styles.textBox}>
                <div className={`${styles.text} ${isAnimating ? styles.newText : styles.oldText}`}>{text}</div>
            </div>
        </TooltipHost>
    );
};

export default RollingStatus;
